// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__YbFiX","label":"Labeled_label__3HWy_","divider":"Labeled_divider__1GsR0"};